module.exports = __webpack_public_path__ + "img/port-miami-cruise-terminals-ropax-facilities.48843e33.png";